var map = {
	"./Jannes.png": "f61a",
	"./LOGO_center.png": "4bd7",
	"./LOGO_letter.png": "4adf",
	"./LOGO_letter_1.png": "a126",
	"./LOGO_letter_2.png": "fb03",
	"./LOGO_letter_square.png": "140f",
	"./cloud.png": "845b",
	"./jola-3d.png": "a4cd",
	"./jola.png": "6b66",
	"./jola_orig.png": "3e4c",
	"./logo_jl.png": "119a",
	"./servers.png": "9c1d",
	"./site-jle.png": "155c",
	"./site-jlo-angled.xcf": "cbe3",
	"./site-jlo-side.png": "0d4b",
	"./site-jlo.png": "14de",
	"./site-kvv.png": "0811",
	"./web-design.png": "1a3b",
	"./webhosting.png": "243b",
	"./websites.png": "2c37"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";